import { withFormElement } from "@brynlabs/webforms-react"
import countryList from "country-list"
import React from "react"

import { withTranslation } from "../../../i18n/translate"
import { makePromiseCancelable } from "../../../util/make-promise-cancelable"
import Select from "../select/select"

const countries = countryList
  .getData()
  .map((c) => {
    return { ...c, code: c.code.toUpperCase() }
  })
  .sort((a, b) => a.name.localeCompare(b.name))

class CountrySelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = { country: undefined }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.country !== this.props.country) {
      this.setState({ country: this.props.country })
    }
    if (prevProps.valueAsString !== this.props.valueAsString) {
      this.setState({
        country: countries.find(
          (country) => country.name === this.props.valueAsString,
        ),
      })
    }
  }

  componentDidMount() {
    this.countryPromise = makePromiseCancelable(
      fetch("https://api.ipcountry.foolsparadise.de/ip")
        .then((res) => {
          if (res.ok) {
            return (res.json().country || "DE").toUpperCase()
          } else {
            throw new Error(
              `Could not fetch country. Status ${res.status}: ${res.statusText}`,
            )
          }
        })
        .catch((error) => {
          console.error(error)
          return "DE"
        }),
    )

    this.countryPromise.promise.then((res) => {
      this.setCountry(countries.find((country) => country.code === res))
    })
  }

  setCountry(country) {
    if (this.props.onSelect) {
      this.props.onSelect(country)
    }
    this.setState({
      country,
    })
  }

  render() {
    const { country } = this.state
    const { t, valueAsString, onSelect, ...props } = this.props

    return (
      <Select
        values={countries}
        name={"country"}
        autocomplete={"country-name"}
        mapValueToString={(val) => val.name}
        onSelect={(val) => this.setCountry(val)}
        value={country}
        {...props}
      />
    )
  }
}

const CountrySelectHoc = withTranslation()(CountrySelect)

const WebformsCountrySelect = withFormElement(
  ({ setData, getData, onSelect = (c) => {}, ...props }) => {
    return (
      <CountrySelect
        onSelect={(country) => {
          setData(country?.name || "")
          onSelect(country)
        }}
        valueAsString={getData()}
        {...props}
      />
    )
  },
)

export { CountrySelectHoc as CountrySelect, WebformsCountrySelect }
